import React, { useEffect, useState, useCallback, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp, faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import axios from 'util/axios';
import { TABLE_DATA } from "util";
import update from "immutability-helper";

const P_TYPE = "all";

const CompleteList = (props) => {
    const { sheetCompleteList } = props;

    let tmp;
    let fidx;
    tmp = TABLE_DATA[P_TYPE];
    let revRowData = [];

    sheetCompleteList.forEach((data, i) => {
        fidx = tmp.findIndex((i) => i.id === data.celNm);
        if (fidx > -1) {
            data = update(data, {
                $merge: tmp[fidx],
            });
        }
        revRowData = [...revRowData, ...[data]];
    });

    const HandleOnClick = (row) => {
        if (row.sheetType?.toString().match(/(IN|OUT|QC)/)) {
            const uniqueCode = row.uniqueCode;
            const celNm = row.celNm;
            const find = document.querySelector(
                "*[data-reviewdata='" + (uniqueCode + celNm) + "']"
            );
            
            const elementPosition = find?.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - 200;

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth",
            });
            find?.classList.add("review-focus");
            setTimeout(() => {
                find?.classList.remove("review-focus");
            },5000)
        }
    };

    return revRowData.map((row, i) => (
        <tr key={`sheetComplete-${i}`} onClick={() => HandleOnClick(row)}>
            <td>{row.sheetType}</td>
            <td>{row.description}</td>
            <td>{row.paraNm}</td>
        </tr>
    ));
};

export default React.memo(CompleteList);
